/* LOGIXA homepage content — RU. Shape must match de.ts exactly. */

export const ru = {
  nav: {
    links: [
      { label: 'Продукт', href: '#plattform' },
      { label: 'Решения', href: '#disposition' },
      { label: 'Интеграции', href: '#integrationen' },
      { label: 'Цены', href: '#preise' },
      { label: 'Ресурсы', href: '/docs' },
    ],
    login: 'Вход',
    demo: 'Заказать демо',
    menu: 'Меню',
  },

  hero: {
    kicker: 'TRANSPORT MANAGEMENT SYSTEM',
    h1: 'TMS-система для транспортных компаний, которым мало одной диспетчеризации.',
    sub: 'Заказы, диспетчеризация, водители, автопарк, GPS, документы и расчёты в одной платформе. LOGIXA связывает всю транспортную организацию — от заказа до счёта.',
    primary: 'Заказать демо',
    secondary: 'Смотреть демо',
    trust: ['Соответствие GDPR', 'Хостинг в Германии', '9 языков', 'Запуск за 12 дней'],
    demoNote: 'Демонстрационные данные',
  },

  mock: {
    search: 'Поиск…',
    user: 'Max Mustermann',
    role: 'ADMIN',
    nav: ['Обзор', 'Заказы', 'Диспетчеризация', 'Транспорт', 'Водители', 'Планирование рейсов', 'GPS-мониторинг', 'Документы', 'Сообщения', 'Отчёты', 'Расчёты', 'Настройки'],
    live: 'LIVE',
    card: {
      id: 'FLEET-DEMO-118',
      route: 'Гамбург, DE → Роттердам, NL',
      etaLbl: 'ETA',
      eta: 'Сегодня, 14:30',
      driverLbl: 'ВОДИТЕЛЬ',
      driver: 'John D.',
      progress: 64,
    },
    ordersTitle: 'Активные заказы',
    orders: [
      { id: 'FLEET-DEMO-118', state: 'В ПУТИ', tone: 'go' },
      { id: 'FLEET-DEMO-117', state: 'В ПУТИ', tone: 'go' },
      { id: 'FLEET-DEMO-116', state: 'ПОГРУЗКА', tone: 'load' },
      { id: 'FLEET-DEMO-115', state: 'ЗАПЛАНИРОВАН', tone: 'plan' },
      { id: 'FLEET-DEMO-114', state: 'ЗАВЕРШЁН', tone: 'done' },
    ],
    kpiTitle: 'KPI сегодня',
    kpis: [
      { lbl: 'ЗАКАЗЫ', val: '850', delta: '+14 %' },
      { lbl: 'ПОРОЖНИЕ', val: '14 %', delta: '−16 %' },
      { lbl: 'ВЫРУЧКА', val: '€92K', delta: '+18 %' },
    ],
    statusTitle: 'Статус транспорта',
    status: [
      { n: '104', lbl: 'В ПУТИ' },
      { n: '18', lbl: 'ПОГРУЗКА' },
      { n: '7', lbl: 'ВЫГРУЗКА' },
      { n: '4', lbl: 'СЕРВИС' },
      { n: '2', lbl: 'ПРОСТОЙ' },
    ],
    plates: [
      { p: 'HH-LOG 33', tone: 'go' },
      { p: 'B-KT 155', tone: 'acc' },
      { p: 'K-AB 147', tone: 'idle' },
    ],
  },

  integrations: {
    label: 'Интегрируется в вашу существующую\nлогистическую инфраструктуру',
    items: ['TIMOCOM', 'Trans.eu', 'DATEV', 'Stripe', 'SEPA', 'n8n', 'Make', 'Zapier'],
  },

  platform: {
    kicker: 'ПЛАТФОРМА',
    h2: 'Ваша компания. Одна система.',
    sub: 'Никаких Excel-таблиц. Никаких отдельных систем для водителей, GPS и расчётов. Никакого поиска информации в пяти инструментах.',
    areas: [
      {
        n: '01',
        title: 'Заказы и диспетчеризация',
        desc: 'Заводить заказы, назначать водителей и машины, планировать рейсы и следить за статусом перевозки в реальном времени.',
        chips: ['Заказы', 'AI-диспетчер', 'Планирование', 'ePOD'],
      },
      {
        n: '02',
        title: 'Автопарк и GPS',
        desc: 'Отслеживать машины онлайн, планировать сервис, контролировать TCO и управлять геозонами.',
        chips: ['Live GPS', 'TCO', 'Сервис', 'Геозоны'],
      },
      {
        n: '03',
        title: 'Водители и комплаенс',
        desc: 'Рабочее время, документы, тахограф и правила EU 561 в одном месте — до того как сроки станут проблемой.',
        chips: ['Тахограф', 'EU 561', 'ADR', 'Модуль 95'],
      },
      {
        n: '04',
        title: 'Расчёты и финансы',
        desc: 'Зарплаты, надбавки, выплаты и процессы DATEV напрямую связаны с операционными данными перевозок.',
        chips: ['Payroll', 'DATEV', 'SEPA', 'Stripe'],
      },
    ],
    cta: 'Смотреть все функции',
  },

  dispatch: {
    kicker: 'УМНАЯ ДИСПЕТЧЕРИЗАЦИЯ',
    h2: 'Диспетчеризация, которая думает.',
    sub: 'LOGIXA учитывает водителей, машины, режимы труда и отдыха, доступность и маршрут — и помогает диспетчеру выбрать оптимальное назначение.',
    points: [
      { title: 'AI-диспетчер', desc: 'Предлагает водителя и машину под конкретный заказ.' },
      { title: 'Оптимизация маршрута', desc: 'Учитывает платные дороги, расстояние, режим труда и топливо.' },
      { title: 'Diesel Intelligence', desc: 'Планирует заправки по актуальным ценам на топливо вдоль маршрута.' },
    ],
    panelTitle: 'Рекомендация маршрута',
    metrics: [
      { lbl: 'Расстояние', val: '1 346 км' },
      { lbl: 'Время в пути', val: '17 ч 25 мин' },
      { lbl: 'Платные дороги', val: '€ 128,40' },
      { lbl: 'CO₂', val: '1 245 кг' },
    ],
    stopsTitle: 'Рекомендуемые заправки',
    live: 'LIVE',
    stops: [
      { city: 'Ганновер', price: '€ 1,59', best: false },
      { city: 'Кассель', price: '€ 1,58', best: false },
      { city: 'Франкфурт', price: '€ 1,55', best: true },
      { city: 'Вюрцбург', price: '€ 1,62', best: false },
    ],
    apply: 'Принять маршрут',
    source: 'Источники цен: Tankerkönig (DE), prix-carburants (FR), E-Control (AT), MITECO (ES)',
  },

  driver: {
    kicker: 'ПРИЛОЖЕНИЕ ВОДИТЕЛЯ',
    h2: 'У водителя всё с собой.',
    sub: 'Нативные приложения для iOS и Android — полный цикл рейса от заказа до подписи, в том числе без сети.',
    flow: ['Получить заказ', 'Запустить навигацию', 'Сканировать документы', 'Подписать ePOD', 'Закрыть рейс'],
    chips: ['iOS', 'Android', 'Офлайн-режим', 'Telegram-бот', '9 языков'],
    phones: [
      {
        tag: 'ЗАКАЗ #DE-1107',
        title: 'Гамбург → Роттердам',
        rows: [
          { lbl: 'ЗАГРУЗКА', val: 'Сегодня 08:30' },
          { lbl: 'ВЫГРУЗКА', val: 'Сегодня 14:30' },
          { lbl: 'ТРАНСПОРТ', val: 'HH-LOG 33' },
          { lbl: 'ГРУЗ', val: '18 паллет · 12,4 т' },
        ],
        action: 'Запустить навигацию',
      },
      {
        tag: 'ДОКУМЕНТЫ',
        title: 'Сканировать CMR',
        rows: [
          { lbl: 'НАКЛАДНАЯ', val: 'CMR-2026-4471' },
          { lbl: 'СТАТУС', val: 'Отсканировано · 2 стр.' },
          { lbl: 'АКТ ПРИЁМКИ', val: 'Ожидается' },
        ],
        action: 'Загрузить скан',
      },
      {
        tag: 'ePOD',
        title: 'Подтвердить приёмку',
        rows: [
          { lbl: 'ПОЛУЧАТЕЛЬ', val: 'De Vries Logistics BV' },
          { lbl: 'ПОДПИСЬ', val: 'Получена' },
          { lbl: 'ФОТО', val: '3 вложения' },
        ],
        action: 'Закрыть рейс',
      },
    ],
  },

  compliance: {
    kicker: 'КОМПЛАЕНС И БЕЗОПАСНОСТЬ',
    h2: 'Видеть режим труда до того, как он станет проблемой.',
    sub: 'Время управления и отдыха, данные тахографа и истекающие документы в одном месте — с предупреждением, пока ещё есть время среагировать.',
    points: [
      { title: 'EU 561', desc: 'Актуальное время управления и отдыха по каждому водителю, постоянная сверка.' },
      { title: 'Тахограф', desc: 'Импорт DDD-файлов и контроль данных водителя.' },
      { title: 'Документы', desc: 'Предупреждения об истечении прав, ADR и Модуля 95.' },
    ],
    dashDriverLbl: 'Водитель',
    dashDriver: 'John D.',
    badge: 'СООТВЕТСТВУЕТ',
    bars: [
      { lbl: 'Управление сегодня', val: '7 ч 45 / 9 ч', pct: 86, tone: 'warn' },
      { lbl: 'Управление за неделю', val: '38 ч 10 / 56 ч', pct: 68, tone: 'ok' },
      { lbl: 'Следующий отдых', val: 'через 1 ч 15 мин', pct: 42, tone: 'ok' },
    ],
    docsTitle: 'Истекающие документы',
    docs: [
      { lbl: 'Водительское удостоверение', val: '12.03.2027', warn: false },
      { lbl: 'Сертификат ADR', val: '18.05.2027', warn: true },
      { lbl: 'Модуль 95', val: '22.09.2027', warn: false },
    ],
    alerts: '3 АКТИВНЫХ ПРЕДУПРЕЖДЕНИЯ',
  },

  onboarding: {
    kicker: 'ПЕРЕХОД',
    h2: 'Всё ещё Excel? Не проблема.',
    sub: 'Переносим водителей, машины и контрагентов из Excel, CSV или вашей текущей TMS.',
    promoTitle: 'Запуск за 12 дней.',
    promoSub: 'Быстро. Надёжно. Без риска.',
    promoCta: 'Заказать демо',
    steps: [
      { tag: 'ДЕНЬ 1', title: 'Разбор процессов', desc: 'Демо и анализ ваших процессов.' },
      { tag: 'ДЕНЬ 2–4', title: 'Пилот', desc: 'Пилотная эксплуатация на реальных машинах.' },
      { tag: 'ДЕНЬ 5–8', title: 'Импорт данных', desc: 'Перенос водителей, машин и справочников.' },
      { tag: 'ДЕНЬ 9–10', title: 'Обучение', desc: 'Обучение диспетчеров и водителей.' },
      { tag: 'ДЕНЬ 11–12', title: 'Запуск', desc: 'Продуктивный старт с полной поддержкой.' },
    ],
  },

  roi: {
    kicker: 'ПОТЕНЦИАЛ ЭКОНОМИИ',
    h2: 'Что LOGIXA меняет в вашем парке.',
    fields: [
      { lbl: 'Транспорт', unit: '' },
      { lbl: 'Водители', unit: '' },
      { lbl: 'Заказов в месяц', unit: '' },
      { lbl: 'Средний пробег на машину в год', unit: 'км' },
    ],
    panelTitle: 'ПОТЕНЦИАЛ В ГОД',
    lines: ['Меньше административной работы', 'Оптимизация порожних пробегов', 'Оптимизация топлива'],
    totalLbl: 'Оценочный потенциал',
    basisLink: 'Показать методику расчёта',
    basisClose: 'Скрыть методику расчёта',
    basis: [
      'Администрирование: 7,50 € на заказ (около 13 минут при ставке 34 €/час) плюс 15 € на водителя в месяц на учёт времени и подготовку зарплаты.',
      'Порожние пробеги: доля порожнего пробега 18 %, из них 5 % устранимы за счёт лучшей диспетчеризации, при стоимости 1,04 € за километр.',
      'Топливо: расход 30 л на 100 км и экономия 2 цента на литр за счёт планирования заправок вдоль маршрута — по актуальным ценам Tankerkönig (DE), prix-carburants (FR), E-Control (AT) и MITECO (ES).',
      'Все значения — оценка на основе типовых отраслевых допущений, а не гарантированная экономия.',
    ],
  },

  pricing: {
    kicker: 'ЦЕНЫ',
    h2: 'Прозрачные цены. Предсказуемо. Честно.',
    sub: 'Выберите тариф под размер вашего парка. Отмена в любой месяц.',
    allLink: 'Все тарифы',
    perMonth: '/ месяц',
    badge: 'РЕКОМЕНДУЕМ',
    cta: 'Заказать демо',
    plans: [
      {
        name: 'STARTER', price: '€199', custom: false, scope: 'до 15 машин',
        features: ['Управление заказами', 'Приложение водителя', 'GPS-мониторинг', 'Поддержка по email'],
      },
      {
        name: 'BUSINESS', price: '€499', custom: false, scope: 'до 50 машин',
        features: ['Все функции Starter', 'AI-диспетчер', 'Тахограф и EU 561', 'Приоритетная поддержка'],
      },
      {
        name: 'ENTERPRISE', price: 'Индивидуально', custom: true, scope: 'от 50 машин',
        features: ['Все функции Business', 'Расширенные права доступа', 'API и интеграции', 'Персональный менеджер'],
      },
    ],
    note: ['Небольшие парки стартуют дешевле: ', 'BASIC от 49 €/месяц', ' до 3 машин, ', 'DRIVER бесплатно', ' для ИП с одним тягачом.'],
  },

  security: {
    title: 'Ваши данные остаются в Европе.',
    items: ['Хостинг в Германии', 'Соответствие GDPR', '2FA и Passkeys', 'Журналы аудита', 'Шифрование при хранении'],
  },

  faq: {
    kicker: 'FAQ',
    h2: 'Частые вопросы о TMS.',
    sub: 'Остались вопросы? Ответим на демо.',
    list: [
      {
        q: 'Что такое TMS-система?',
        a: 'Transport Management System объединяет обработку заказов, диспетчеризацию, управление транспортом и водителями, документы и расчёты в одной платформе — вместо разрозненных Excel-таблиц, GPS-порталов и бухгалтерских программ.',
      },
      {
        q: 'Каким компаниям подходит LOGIXA?',
        a: 'Транспортным компаниям от 3 до более чем 50 машин. ИП с одним тягачом стартуют на бесплатном тарифе DRIVER, небольшие парки — на BASIC от 49 €/месяц, средние компании — на STARTER или BUSINESS.',
      },
      {
        q: 'Может ли LOGIXA заменить Excel?',
        a: 'Да. Заказы, водители, машины, справочники и расчёты живут в одной базе, а не в разрозненных таблицах. Существующие файлы Excel и CSV мы переносим при переходе — вы стартуете на своих данных.',
      },
      {
        q: 'Сколько занимает внедрение?',
        a: 'Мы планируем переход за 12 дней: анализ процессов, пилот на реальных машинах, импорт данных, обучение и запуск. Это наш регламент работы, а не усреднённый показатель по клиентским проектам.',
      },
      {
        q: 'Можно ли оставить действующий GPS?',
        a: 'Во многих случаях да. LOGIXA снимает позиции через приложение водителя без дополнительного оборудования и параллельно может принимать телематику из существующих систем. Какой вариант подключения возможен у вас — определяем до старта.',
      },
      {
        q: 'Поддерживает ли LOGIXA тахограф и EU 561?',
        a: 'Время управления и отдыха по EU 561 считается по каждому водителю постоянно, с предупреждениями до превышения. DDD-файлы тахографа можно импортировать и просматривать; как официальная расшифровка тахографа для контролирующих органов эта обработка не предназначена.',
      },
      {
        q: 'Есть ли приложение для водителя?',
        a: 'Да, нативные приложения для iOS и Android на девяти языках: заказ, навигация, скан документов, подпись ePOD и закрытие рейса — в том числе офлайн. Дополнительно есть Telegram-бот для водителей без установленного приложения.',
      },
      {
        q: 'Можно ли подключить TIMOCOM и Trans.eu?',
        a: 'Коннекторы подготовлены и написаны по документированным интерфейсам. Активация идёт через ваш собственный договор с TIMOCOM или Trans.eu; при внедрении мы настраиваем соединение вместе и тестируем его с вашими доступами.',
      },
      {
        q: 'Где хранятся данные?',
        a: 'На серверах в Германии, в соответствии с GDPR, с шифрованием при передаче и хранении. Доступы протоколируются, вход можно защитить 2FA и Passkeys.',
      },
      {
        q: 'Сколько стоит LOGIXA?',
        a: 'DRIVER бесплатен для ИП с одним тягачом, BASIC начинается с 49 €/месяц до 3 машин, STARTER стоит 199 €/месяц до 15 машин, BUSINESS — 499 €/месяц до 50 машин. От 50 машин считаем индивидуально. Все тарифы отменяются помесячно.',
      },
    ],
  },

  finalCta: {
    h2: 'Посмотрите LOGIXA на своих транспортных процессах.',
    sub: 'За 30 минут демо покажем именно те модули, которые важны для вашего парка.',
    primary: 'Заказать демо',
    secondary: 'Смотреть демо',
  },

  footer: {
    tagline: 'TMS-система для транспортных и экспедиторских компаний в Европе.',
    cols: [
      {
        title: 'ПРОДУКТ',
        links: [
          { label: 'Функции', href: '/platform/funktionen' },
          { label: 'AI-диспетчер', href: '/platform/ki' },
          { label: 'Приложение водителя', href: '/platform/funktionen#apps' },
          { label: 'Планирование рейсов', href: '/platform/funktionen#tourenplanung' },
          { label: 'Расчёты', href: '/platform/backoffice' },
        ],
      },
      {
        title: 'РЕШЕНИЯ',
        links: [
          { label: 'Небольшие компании', href: '/pricing' },
          { label: 'Средние автопарки', href: '/pricing' },
          { label: 'Международные перевозки', href: '/platform/funktionen' },
          { label: 'Водители-ИП', href: '/pricing' },
        ],
      },
      {
        title: 'ИНТЕГРАЦИИ',
        links: [
          { label: 'TIMOCOM', href: '/platform/integrationen' },
          { label: 'Trans.eu', href: '/platform/integrationen' },
          { label: 'DATEV', href: '/platform/integrationen' },
          { label: 'Telegram', href: '/platform/integrationen' },
          { label: 'Все интеграции', href: '/platform/integrationen' },
        ],
      },
      {
        title: 'РЕСУРСЫ',
        links: [
          { label: 'База знаний', href: '/docs' },
          { label: 'Блог', href: '/blog' },
          { label: 'Что такое TMS?', href: '/docs' },
          { label: 'Стоимость TMS', href: '/pricing' },
          { label: 'Центр помощи', href: '/docs' },
        ],
      },
      {
        title: 'КОМПАНИЯ',
        links: [
          { label: 'О нас', href: '/about' },
          { label: 'Вакансии', href: '/jobs' },
          { label: 'Партнёры', href: '/companies' },
          { label: 'Контакты', href: '/kontakt' },
        ],
      },
    ],
    copyright: '© 2026 LOGIXA. Все права защищены.',
    legal: [
      { label: 'Конфиденциальность', href: '/datenschutz' },
      { label: 'Импрессум', href: '/impressum' },
      { label: 'Условия', href: '/agb' },
      { label: 'Безопасность', href: '/platform/funktionen#sicherheit' },
    ],
  },
};
